import { all, takeEvery } from 'redux-saga/effects'
import * as actions from './data-gateway.actions'

import { fetchPersonFromDGSaga } from './sagas/fetch-person-from-dg'

export default function* () {
  yield all([takeEvery(actions.FETCH_DATA_GATEWAY_REQUEST, fetchPersonFromDGSaga)])
}
